import { createSvgIcon } from '@material-ui/core';
import moment from 'moment';

import { HelpIcon } from '~/icons';
import { getLocalStorageItem } from '~/utils/localStorage';

const NewContentIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_69385_73795)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.3986 4.3986C6.34317 2.45406 9.0317 1.25 12 1.25C14.9683 1.25 17.6568 2.45406 19.6014 4.3986L19.0711 4.92893L19.6014 4.3986C21.5459 6.34317 22.75 9.0317 22.75 12C22.75 14.9683 21.5459 17.6568 19.6014 19.6014C17.6568 21.5459 14.9683 22.75 12 22.75C9.0317 22.75 6.34317 21.5459 4.3986 19.6014L4.92893 19.0711L4.3986 19.6014C2.45406 17.6568 1.25 14.9683 1.25 12C1.25 9.0317 2.45406 6.34317 4.3986 4.3986L4.3986 4.3986ZM12 2.75C9.4455 2.75 7.13403 3.78452 5.45926 5.45926C3.78451 7.13404 2.75 9.4455 2.75 12C2.75 14.5545 3.78452 16.866 5.45926 18.5407C7.13403 20.2155 9.4455 21.25 12 21.25C14.5545 21.25 16.866 20.2155 18.5407 18.5407C20.2155 16.866 21.25 14.5545 21.25 12C21.25 9.4455 20.2155 7.13403 18.5407 5.45926C16.866 3.78452 14.5545 2.75 12 2.75Z"
        fill="#BDBDBD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18.8125C12.6904 18.8125 13.25 18.2529 13.25 17.5625C13.25 16.8722 12.6904 16.3125 12 16.3125C11.3097 16.3125 10.75 16.8722 10.75 17.5625C10.75 18.2529 11.3097 18.8125 12 18.8125Z"
        fill="#BDBDBD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 9.3125C8.25 7.24144 9.92894 5.5625 12 5.5625C14.0711 5.5625 15.75 7.24144 15.75 9.3125C15.75 11.1267 14.4617 12.64 12.75 12.9875V14.3125C12.75 14.7267 12.4142 15.0625 12 15.0625C11.5858 15.0625 11.25 14.7267 11.25 14.3125V12.3125C11.25 11.8983 11.5858 11.5625 12 11.5625C13.2426 11.5625 14.25 10.5551 14.25 9.3125C14.25 8.06986 13.2426 7.0625 12 7.0625C10.7574 7.0625 9.75 8.06986 9.75 9.3125C9.75 9.72671 9.41421 10.0625 9 10.0625C8.58579 10.0625 8.25 9.72671 8.25 9.3125Z"
        fill="#BDBDBD"
      />
      <rect x="15.5" y="-0.5" width="9" height="9" rx="4.5" fill="#75DB29" />
      <rect x="15.5" y="-0.5" width="9" height="9" rx="4.5" stroke="#212121" />
    </g>
    <defs>
      <clipPath id="clip0_69385_73795">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'NewContentIcon'
);

export function HelpCenterIcon({ appId, helpContentUpdatedAt }) {
  const helpCenterLastOpenedAt = getLocalStorageItem('helpCenter')?.[appId];

  const isNewContent =
    helpContentUpdatedAt &&
    (!helpCenterLastOpenedAt || moment(helpCenterLastOpenedAt).isBefore(helpContentUpdatedAt));

  const Icon = isNewContent ? NewContentIcon : HelpIcon;
  return <Icon />;
}
